/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum FantaGroupTeamState {
    ACCEPTED = 'accepted',
    INVITED = 'invited',
    DENIED = 'denied',
    LEAVED = 'leaved',
}
